<template>
  <v-container ma-0 :class="{'pa-0' : !equipmentId }" v-if="workRequestPassport">
    <v-layout column>
      <v-toolbar color="cyan" dark :dense="$vuetify.breakpoint.smAndDown">
        <button @click="showfilter = !showfilter">
          <v-icon>filter_list</v-icon>
        </button>
        <v-toolbar-title>{{ $t('equipment.workRequests.title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn icon>
          <v-icon>search</v-icon>
        </v-btn>-->
        <v-text-field
          v-if="$vuetify.breakpoint.mdAndUp"
          v-model="search"
          class="pt-1"
          append-icon="search"
          :label="$t('search')"
          single-line
          hide-details
        ></v-text-field>
        <v-menu v-if="!this.$vuetify.breakpoint.mdAndUp" :close-on-content-click="false">
          <template v-slot:activator="{on}">
            <v-btn v-on="on" icon class="mb-0">
              <v-icon>search</v-icon>
            </v-btn>
          </template>
          <v-flex pa-2 white><v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field></v-flex>
        </v-menu>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon class="ma-0" 
              @click="updateWorkRequestsList()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>sync</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('equipment.workRequests.refresh') }}</span>
        </v-tooltip>
        <template v-slot:extension class="px-0">
          <v-tabs color="cyan" dark slider-color="yellow" v-model="tab">
            <v-tab key="active">
              {{ $t('equipment.workRequests.active') }}
              <v-icon class="ml-2">build</v-icon>
            </v-tab>
            <v-tab key="archive">
              {{ $t('equipment.workRequests.archive') }}
              <v-icon class="ml-2">list</v-icon>
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-layout row slot="extension" wrap v-if="showfilter">
        <v-flex v-for="header in headers" :key="header.text" xs12 md4 sm6>
          <div v-if="filters.hasOwnProperty(header.value)">
            <v-combobox
              :label="header.text"
              flat
              multiple
              clearable
              :items="columnValueList(header.value)"
              :menu-props="menuProps"
              @click:append="closeMenu()"
              @click="openMenu()"
              v-model="filters[header.value]"
              color="blue"
              small-chips
              deletable-chips
              dense
              :prepend-icon="header.icon"
            ></v-combobox>
          </div>
        </v-flex>
      </v-layout>
      <v-tabs-items touchless>
        <v-tab-item key="active" lazy>
          <v-data-table
            v-model="selected"
            :headers="headersActive"
            :items="tab ? itemsArchive : itemsActive"
            :rows-per-page-items="workRequestView"
            :pagination.sync="pagination"
            item-key="IdApplication"
            class="elevation-1"
            :dense="$vuetify.breakpoint.smAndDown"
            :search="search"
            :loading="loading"
          >
            
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.value"
                  class="text-xs-center"
                  :class="['column sortable', header.class, pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td>
                  <div class="d-flex align-center confirmationWidth">
                    <v-icon :color="props.item.Color">{{ props.item.Icon }}</v-icon>
                  </div>
                </td>
                <td class="text-xs-center px-0">
                  <router-link
                    v-if="isAuthenticated"
                    :to="{ name: 'workRequest', params: { idapplication: props.item.IdApplication } }"
                  >
                    <span>{{props.item.IdApplication}}</span>
                  </router-link>
                  <span v-else>{{props.item.IdApplication}}</span>
                </td>
                <!-- <td class="text-xs-center px-1 minWidth">{{ props.item.TechPlaceName }}</td> -->
                <td class="text-xs-center px-0">{{ props.item.StageName }}</td>
                <td class="text-xs-center px-0 minWidthContent">{{ props.item.Content }}</td>
                <td class="text-xs-center px-0">{{ props.item.DatePlanString }}</td>
                <td class="text-xs-center px-0">{{ props.item.DatePlanEndString }}</td>
                <td class="text-xs-center">{{ props.item.DirectionName }}</td>
                <td class="text-xs-center" :class="{'d-none': tab}">{{ props.item.TimeAfterCreation }}</td>
                <td>
                  <v-btn
                    icon
                    v-if="props.item.AttachmentCount > 0"
                    @click.native.stop="$router.push({ name: 'WorkRequestAttachments', params: { workRequestId: props.item.IdApplication } })"
                  >
                    <v-icon>attach_file</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'WorkRequests',
  props: {
    equipmentId: String,
    params: Object
  },
  data() {
    return {
      pagination: {
        sortBy: 'name'
      },
      tab: 0,
      search: '',
      massList: [],
      filteredMassList: [],
      comment: '',
      action: '',
      workRequest: {},
      openDialog: false,
      reject: false,
      saveSelected: [],
      dateEnd: new Date().toISOString().substr(0, 10).toLocaleString(),
      showfilter: false,
      menuProps: {},
      filters: {
        DeclarerName: [],
        ResponsibleName: [],
        CategoryName: [],
        DirectionName: [],
        TechPlaceName: [],
        StageName: []
      },
    }
  },
  mounted() {
    if (!this.equipmentId) {
      //this.updateWorkRequestsList()
      this.pagination.rowsPerPage = 12
    }
  },
  methods: {
    ...mapActions([
      'workRequestStageMass',
      'clearWorkRequestStageMessage',
      'updatePassportWorkRequests',
      'сonfirmationList',
      'updateWorkRequests'
    ]),
    updateWorkRequestsList() {
     
      if (this.equipmentId) {
        this.updatePassportWorkRequests({workRequestId: 0, filterMode: 'byEquipment', AdditionalParams: { equipmentCode: this.equipmentId, showArchive: true }})
      }
    },
    showfilterLogic() {
      this.filters.DeclarerName.length 
      || this.filters.ResponsibleName.length 
      || this.filters.CategoryName.length 
      || this.filters.DirectionName.length 
      || this.filters.TechPlaceName.length 
      || this.filters.StageName.length ? this.showfilter = true : this.showfilter = false
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    columnValueList(val) {
      return this.workRequestPassport.map(e => e[val]).sort()
    },
    closeMenu() {
      this.menuProps = { value: false }
    },
    openMenu() {
      this.menuProps = {}
    },
  },
  computed: {
    workRequestView() {
      return this.equipmentId ? [5,10,25,{'text': '$vuetify.dataIterator.rowsPerPageAll','value': -1}] : [12, 36, 108, {'text': '$vuetify.dataIterator.rowsPerPageAll','value': -1}]
    },
    viewType: {
      get() {
        return this.$store.state.base.viewType
      },
      set(newValue) {
        this.$store.state.base.viewType = newValue
      }
    },
    selected: {
      get() {
        return this.$store.state.base.selected
      },
      set(newValue) {
        this.$store.state.base.selected = newValue
      }
    },
    confirmationList() {
      return this.$store.state.workRequests.workRequestConfirmationList
    },
    itemsArchive() {
      if(this.tab) {
        return this.workRequestPassport.filter( e => e.StageCode == 'A').filter(e => {
          return Object.keys(this.filters).every(f => {
            return this.filters[f].length < 1 || this.filters[f].includes(e[f])
          })
        })
      } else {
        return []
      }
    },
    itemsActive() {
      if(!this.tab) {
        return this.workRequestPassport.filter( e => e.StageCode != 'A').filter(e => {
          return Object.keys(this.filters).every(f => {
            return this.filters[f].length < 1 || this.filters[f].includes(e[f])
          })
        })
      } else {
        return []
      }
    },
    loading() {
      return this.$store.state.base.loading
    },
    snackbarText: {
      get() {
        return this.$store.state.equipmentData.snackbarText
      },
      set(newValue) {
        this.$store.state.equipmentData.snackbarText = newValue
      }
    },
    workRequestPassport() {
      return this.tab ? this.$store.state.equipmentData.passportWorkRequests.filter( e => e.StageCode == 'A') : this.$store.state.equipmentData.passportWorkRequests.filter( e => e.StageCode != 'A')
    },
    headers() {
      return [
        {
          text: this.$t('equipment.workRequests.declarerName'),
          value: 'DeclarerName',
          icon: 'person'
        },
        {
          text: this.$t('equipment.workRequests.responsibleName'),
          value: 'ResponsibleName',
          icon: 'directions_run'
        },
        {
          text: this.$t('equipment.workRequests.stage'),
          value: 'StageName',
          icon: 'control_camera'
        },
        {
          text: this.$t('equipment.workRequests.categoryName'),
          value: 'CategoryName',
          icon: 'category'
        },
        {
          text: this.$t('equipment.workRequests.directionName'),
          value: 'DirectionName',
          icon: 'directions'
        },
        {
          text: this.$t('equipment.workRequests.techPlaceName'),
          value: 'TechPlaceName',
          icon: 'home'
        }
      ]
    },
    headersActive() {
      return  [
        { text: '', value: 'Icon' },
        {
          text: this.$t('equipment.workRequests.number'),
          value: 'IdApplication',
          class: 'text-xs-center'
        },
        // {
        //   text: this.$t('equipment.resources.techPlaceName'),
        //   value: 'TechPlaceName',
        //   class: 'minWidth'
        // },
        // { text: "Статус", value: "Status" },
        { text: this.$t('equipment.workRequests.stage'), 
          value: 'StageName',
          class: 'pl-1'
        },
        {
          text: this.$t('equipment.workRequests.content'),
          align: 'left',
          value: 'Content',
          class: 'minWidthContent pl-1'
        },
        {
          text: this.$t('equipment.workRequests.startDateShort'),
          align: 'left',
          value: 'sortablePlanStart',
          sortable: false,
          class: 'px-0'
        },
        {
          text: this.$t('equipment.workRequests.endDateShort'),
          align: 'left',
          value: 'sortablePlanEnd',
          sortable: false,
          class: 'px-0'
        },
        {
          text: this.$t('equipment.workRequests.directionName'),
          value: 'DirectionName'
        },
        {
          text: this.$t('equipment.workRequests.hoursAfterCreation'),
          value: 'HoursAfterCreation',
          class: this.tab ? 'd-none' : ''
        },
        {
          text: this.$t('equipment.workRequests.attachmentCount'),
          value: 'AttachmentCount'
        }
      ]
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    }
  },
  watch: {
    tab() {
      this.filters = {
        DeclarerName: [],
        ResponsibleName: [],
        CategoryName: [],
        DirectionName: [],
        TechPlaceName: [],
        StageName: []
      }
    }
  }
}
</script>

<style scoped>
a {
  color: rgb(0, 153, 255) !important;
}
.minWidth {
  min-width: 135px
}
.minWidthContent {
  min-width: 300px
}
.confirmationWidth {
  min-width: 30px;
  max-width: 50px
}
</style>
